import { infoStableSwapClient, v2Clients } from 'utils/graphql'
import { GraphQLClient } from 'graphql-request'

import { ChainId } from '@pancakeswap/chains'
import { pulse } from 'config/chains'
import mapValues from 'lodash/mapValues'
import { BLOCKS_CLIENT_WITH_CHAIN } from 'config/constants/endpoints'

export type MultiChainName = 
  | 'PULSE'

export type MultiChainNameExtend = MultiChainName

export const multiChainName: Record<ChainId, MultiChainNameExtend> = {
  [ChainId.PULSE]: 'PULSE',
}

export const multiChainQueryMainToken: Record<MultiChainName, string> = {
  PULSE: 'PLS',
}

export const multiChainBlocksClient: Record<MultiChainNameExtend, string> = {
  PULSE: BLOCKS_CLIENT_WITH_CHAIN[ChainId.PULSE],
}

export const multiChainStartTime = {
  PULSE: 1698393775,
}

export const multiChainBlockTime = {
  PULSE: 1000,
}

export const multiChainStartBlock = {
  PULSE: 18672539,
}

export const multiChainId: Record<MultiChainName, ChainId> = {
  PULSE: ChainId.PULSE,
}

export const multiChainPaths = {
  [ChainId.PULSE]: '/pulse',
}

export const multiChainQueryClient = {
  PULSE: v2Clients[ChainId.PULSE],
}

export const multiChainScan: Record<MultiChainName, string> = {
  PULSE: pulse.blockExplorers.default.name,
}

export const multiChainTokenBlackList: Record<MultiChainName, string[]> = mapValues(
  {
    PULSE: ['0x'],
  },
  (val) => val.map((address) => address.toLowerCase()),
)

export const multiChainTokenWhiteList: Record<MultiChainName, string[]> = mapValues(
  {
    PULSE: [],
  },
  (val) => val.map((address) => address.toLowerCase()),
)

export const getMultiChainQueryEndPointWithStableSwap = (chainName: MultiChainNameExtend, isStableSwap: boolean = false): GraphQLClient => {
  if (isStableSwap) return infoStableSwapClient
  return multiChainQueryClient[chainName]
}

export const getMultiChainQueryEndPointWithStableSwapPulseX = (chainName: MultiChainNameExtend, isStableSwap: boolean = false): GraphQLClient => {
  if (isStableSwap) return infoStableSwapClient
  return new GraphQLClient("https://graph.pulsechain.com/subgraphs/name/pulsechain/pulsex")
}

// FIXME: this should be per chain
export const subgraphTokenName = {
  // '0x738d96Caf7096659DB4C1aFbf1E1BDFD281f388C': 'Ankr Staked MATIC',
  // '0x14016E85a25aeb13065688cAFB43044C2ef86784': 'True USD Old',
}

// FIXME: this should be per chain
export const subgraphTokenSymbol = {
  // '0x14016E85a25aeb13065688cAFB43044C2ef86784': 'TUSDOLD',
}

export const checkIsStableSwap = () => window.location.href.includes('stableSwap')

export const ChainLinkSupportChains = [ChainId.PULSE]
